module.exports = __webpack_public_path__ + "static/media/ETN_330.bbb71e9c.png";